import {IntegrationResult} from 'common/models/success';
import {defaultStyles} from 'ui/constants';

import postMessage from './postMessage';

export const ping = () => postMessage('ping');

export const sendHeight = (height: number) => postMessage({'iframe-height': Math.round(height)});

export const sendIntegrationResults = (results: IntegrationResult[]) =>
    postMessage({message: 'integration-results', integrations: results});

export const sendAnswerKey = (key: string) => postMessage({message: 'sent', answer_key: key});

export const sendPageInfo = (type: string) => postMessage({type, url: window.location.href});

export const sendUnload = () => postMessage('unloading');

export const sendLoad = () => postMessage('loading');

export const sendStylesReady = () => postMessage({message: 'styles-ready', defaultStyles});
